// extracted by mini-css-extract-plugin
export default {"rcorners1":"OrderItem_rcorners1__Agm8+","productPriceLineThrough":"OrderItem_productPriceLineThrough__CesX8","cardImgTop":"OrderItem_cardImgTop__ccSp+"};